<app-page-meta pageTitle="finzy - Investor Relations"
               tags="finzy, peer to peer lending, peer to peer lending india, line of credit online, easy finance, need a loan, india credit finance, personal loans, easy loans, loan, loan india, current loan rates india, best loans india, best loan rates, cheapest loans india, high investment investment opportunities, investments, quick personal loans, low interest personal loans"
               description="Welcome to finzy.com, a portal run by Bridge Fintech Solutions Private Limited (“finzy”). finzy is committed to respecting your online privacy and recognizes your need for appropriate protection and management of any information you share with finzy on finzy.com (the “Website”).">
</app-page-meta>
<app-header></app-header>

<div class="container">
    <div><p class="header">INVESTOR RELATIONS
    </div>

    <div class="row">
        <div class="main-row">
            <p class="main-content">The domain name www.finzy.com is owned and operated by Bridge
                Fintech Solutions Private Limited,
                a private limited company incorporated under the Companies Act, 2013 (Company Identification Number
                U74999MH2016PTC286583) with its registered office at, L&T Crescent Bay, T-5, 2002, Jerbai Wadi Road,
                Parel, Mumbai 400 012, Maharashtra, India</p>

        </div>
        <div class="main-row">
            <p class="main-title">Bridge Fintech Solutions Private Limited Financials:</p>
            <div class="menu-item">
                <li>
                    <a [href]="getPolicyFileUrlByName('annualReport')"
                       target="_blank">Download Report for FY 2020 2021</a></li>
            </div>
        </div>
    </div>
</div>
